import styled from 'styled-components';

export const ContainerStyled = styled.div`
  margin-top: -4px;
  width: 100%;

  flex-wrap: wrap;
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: space-between;
`;

export const BaseHeaderStyled = styled.h1`
  font-weight: 500;
  font-size: 24px;
`;

export const EditableHeaderStyled = styled(BaseHeaderStyled)`
  min-width: 500px;
  flex: 1 500px;
`;

export const StaticHeaderStyled = styled(BaseHeaderStyled)`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const ActionsStyled = styled.div`
  display: flex;
  gap: 4px;
  flex: none;
  padding: 4px 0px;
`;
